import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
import _reduceInstanceProperty from "@babel/runtime-corejs3/core-js/instance/reduce";
import _Object$values from "@babel/runtime-corejs3/core-js/object/values";
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js/instance/includes";
import _sliceInstanceProperty from "@babel/runtime-corejs3/core-js/instance/slice";
import Err from "../../../../routes/error";
import { SET_NOTIFICATION_PREFERENCES, SET_PERSONAL_DETAILS, SET_ACCOUNT_DETAILS, SET_SESSION_DETAILS, SET_EMAIL_VERIFICATION, SET_AGENT_ACCOUNT_DETAILS, SET_EMAIL_VERIFIED, SET_EMAIL_SENT, SET_ACCOUNT_AGENTS } from "./account-mutations";
import { getNotificationPreferences, updateNotificationPreferences, updatePersonalDetails, changePassword, uploadToS3, setProfilePhoto, getPhotoSignedURL, removeProfilePhoto, getAccountDetails, verifyAccountEmail, verifyAccountEmailCode, resendConfirmationLink, resendConfirmationCode, createAccount, getAgentAccountDetails, login, checkIfAccountEmailExists, getAgents, getLenderDocuments, downloadAllDocumentsAsZip, downloadDocument, downloadAllDocumentsAsPdf, verifyLenderCode, markDocumentsDownloaded } from "../../api/account-api";
import { clearPreferencesBooleans, delay, openFileDialog, pollApiCall } from "@Shared/utils/utils";
import i18n from "@Shared/@i18n";
import { getAccountsApi, putAccountsApi } from "@Shared/@Utils/ajax";
import { checkSubdomainRedirectionToken } from "@Client/@Utils/custom";
import { TOASTR_ERROR_OPTIONS, TOASTR_OPTIONS, showToast } from "@Shared/@Utils/constants";
import Amplitude from "@Shared/@Utils/amplitude";
import Vue from "vue";
import { isEmpty } from "lodash";
export const INIT_SESSION = "INIT_SESSION";
export const END_SESSION = "END_SESSION";
export const LOAD_NOTIFICATION_PREFERENCES = "LOAD_NOTIFICATION_PREFERENCES";
export const UPDATE_NOTIFICATION_PREFERENCES = "UPDATE_NOTIFICATION_PREFERENCES";
export const LOAD_PERSONAL_DETAILS = "LOAD_PERSONAL_DETAILS";
export const UPDATE_PERSONAL_DETAILS = "UPDATE_PERSONAL_DETAILS";
export const UPDATE_PASSWORD = "UPDATE_PASSWORD";
export const LOAD_ACCOUNT_DETAILS = "LOAD_ACCOUNT_DETAILS";
export const UPDATE_ACCOUNT_DETAILS = "UPDATE_ACCOUNT_DETAILS";
export const UPDATE_PROFILE_PHOTO = "UPDATE_PROFILE_PHOTO";
export const REMOVE_PROFILE_PHOTO = "REMOVE_PROFILE_PHOTO";
export const UPDATE_LOCALE_PREFERENCES = "UPDATE_LOCALE_PREFERENCES";
export const LOGIN = "LOGIN";
export const CREATE_ACCOUNT = "CREATE_ACCOUNT";
export const VERIFY_ACCOUNT_EMAIL_LINK = "VERIFY_ACCOUNT_EMAIL_LINK";
export const VERIFY_ACCOUNT_EMAIL_CODE = "VERIFY_ACCOUNT_EMAIL_CODE";
export const RESEND_CONFIRMATION_LINK = "RESEND_CONFIRMATION_LINK";
export const RESEND_CONFIRMATION_CODE = "RESEND_CONFIRMATION_CODE";
export const CHECK_SUBDOMAIN = "CHECK_SUBDOMAIN";
export const LOAD_AGENT_ACCOUNT_DETAILS = "LOAD_AGENT_ACCOUNT_DETAILS";
export const RESEND_CONFIRMATION_EMAIL = "RESEND_CONFIRMATION_EMAIL";
export const SEND_CONFIRMATION_EMAIL = "SEND_CONFIRMATION_EMAIL";
export const CHECK_IF_EMAIL_ACCOUNT_EXISTS = "CHECK_IF_EMAIL_ACCOUNT_EXISTS";
export const LOAD_ACCOUNT_AGENTS = "LOAD_ACCOUNT_AGENTS";
export const DOWNLOAD_ALL_PDF = "DOWNLOAD_ALL_PDF";
export const DOWNLOAD_COMBINED_PDF = "DOWNLOAD_COMBINED_PDF";
export const LOAD_LENDER_DATA = "LOAD_LENDER_DATA";
export const VERIFY_LENDER_PIN = "VERIFY_LENDER_PIN";
export const MARK_DOCUMENTS_DOWNLOADED = "MARK_DOCUMENTS_DOWNLOADED";
export const DOCUMENTS_ADDED_NOTIFICATION = "DOCUMENTS_ADDED_NOTIFICATION";
export const LOAD_AGENT_DETAILS_WITH_SUBDOMAIN = "LOAD_AGENT_DETAILS_WITH_SUBDOMAIN";
export const LINK_CLIENT_WITH_BROKERAGE = "LINK_CLIENT_WITH_BROKERAGE";
const actions = {
  [INIT_SESSION]: (context, session) => {
    context.commit(SET_SESSION_DETAILS, session);
  },
  [END_SESSION]: context => {
    $["flushPool"]();
    Amplitude.endSession();
    context.commit("clearState", {}, {
      root: true
    });
  },
  [LOAD_NOTIFICATION_PREFERENCES]: async context => {
    try {
      const preferences = await getNotificationPreferences();
      context.commit(SET_NOTIFICATION_PREFERENCES, {
        preferences
      });
    } catch (e) {
      Err.handle(e, {}, "failedToLoadNotificationPreferences");
    }
  },
  [UPDATE_NOTIFICATION_PREFERENCES]: async (context, {
    preferences
  }) => {
    const currentPreferences = context.state.notificationPreferences;
    const clearedPreferences = clearPreferencesBooleans(preferences);
    try {
      var _context;
      await updateNotificationPreferences(_reduceInstanceProperty(_context = _Object$values(clearedPreferences)).call(_context, (acc, current) => {
        return _objectSpread(_objectSpread({}, acc), current);
      }, {}));
      context.commit(SET_NOTIFICATION_PREFERENCES, {
        preferences: clearedPreferences
      });
    } catch (e) {
      context.commit(SET_NOTIFICATION_PREFERENCES, {
        preferences: currentPreferences
      });
      Err.handle(e, {}, "Failed to update notification preferences, try again.");
    }
  },
  [LOAD_PERSONAL_DETAILS]: async context => {
    try {
      const {
        userDetails,
        accountDetails
      } = await getAccountDetails();
      context.commit(SET_PERSONAL_DETAILS, userDetails);
      context.commit(SET_ACCOUNT_DETAILS, {
        accountDetails
      });
    } catch (e) {
      Err.handle(e, {}, "failedToLoadPersonalDetails");
    }
  },
  [UPDATE_PERSONAL_DETAILS]: async (context, userDetails) => {
    try {
      await updatePersonalDetails(userDetails);
      context.commit(SET_PERSONAL_DETAILS, userDetails);
    } catch (e) {
      Err.handle(e, {}, "failedToUpdatePersonalDetails");
      throw e;
    }
  },
  [UPDATE_PASSWORD]: async (context, {
    currentPassword,
    newPassword,
    email
  }) => {
    try {
      await changePassword(currentPassword, newPassword, email);
    } catch (e) {
      Err.handle(e, {}, "failedToUpdatePassword");
      throw e;
    }
  },
  [LOAD_ACCOUNT_DETAILS]: async context => {
    try {
      const {
        accountDetails
      } = Vue.auth.session.get();
      context.commit(SET_ACCOUNT_DETAILS, {
        accountDetails
      });
    } catch (e) {
      Err.handle(e, {}, "failedToLoadAccountDetails");
      throw e;
    }
  },
  [UPDATE_ACCOUNT_DETAILS]: async (context, accountDetails) => {
    try {
      context.commit(SET_ACCOUNT_DETAILS, {
        accountDetails
      });
    } catch (e) {
      Err.handle(e, {}, "failedToUpdatePersonalDetails");
    }
  },
  [UPDATE_PROFILE_PHOTO]: async (context, {
    croppedImage,
    username
  }) => {
    try {
      const name = `profile-${username}.png`;
      const signed = await getPhotoSignedURL(name);
      await uploadToS3(croppedImage, signed.url, signed.contentType);
      await setProfilePhoto();
      const photoVersion = context.state.userDetails.photoVersion || 0;
      const userDetails = {
        photoVersion: photoVersion + 1,
        profilePhoto: true
      };
      context.commit(SET_PERSONAL_DETAILS, userDetails);
    } catch (e) {
      Err.handle(e, {}, "failedToUpdateProfilePhoto");
    }
  },
  [REMOVE_PROFILE_PHOTO]: async context => {
    try {
      await removeProfilePhoto();
      const userDetails = {
        profilePhoto: false
      };
      context.commit(SET_PERSONAL_DETAILS, userDetails);
    } catch (e) {
      Err.handle(e, {}, "failedToRemoveProfilePhoto");
    }
  },
  [UPDATE_LOCALE_PREFERENCES]: async (context, languagePreferences) => {
    try {
      const currentUserDetails = context.state.userDetails;
      const {
        timezone
      } = context.state.accountDetails;
      const userDetails = _objectSpread(_objectSpread(_objectSpread({}, currentUserDetails), languagePreferences), {}, {
        timezone
      });
      await updatePersonalDetails(userDetails);
      context.commit(SET_ACCOUNT_DETAILS, {
        accountDetails: languagePreferences
      });
    } catch (e) {
      Err.handle(e, {
        languagePreferences
      }, "Failed to update account preferences");
      throw e;
    }
  },
  [LOGIN]: async (context, {
    email,
    password,
    subdomain,
    deviceConfig
  }) => {
    try {
      var _context2;
      const res = await login(email, password, subdomain != null ? subdomain : "", deviceConfig);
      const {
        accountType
      } = res.accountDetails;
      if (_includesInstanceProperty(_context2 = ["broker", "agent"]).call(_context2, accountType)) throw new Error("User is not authorized");
      res.email = email;
      return res;
    } catch (e) {
      var _e$responseJSON;
      const responseJSONCode = (_e$responseJSON = e.responseJSON) == null ? void 0 : _e$responseJSON.code;
      if (responseJSONCode === "UserNotConfirmedException" || responseJSONCode == 6) {
        context.commit(SET_EMAIL_VERIFICATION, {
          pendingEmailVerification: true,
          email: email
        });
        return {
          pendingEmailVerification: true
        };
      }
      Err.handle(e, {}, !e.responseJSON && e.message);
    }
    return false;
  },
  [CREATE_ACCOUNT]: async (context, {
    accountDetails
  }) => {
    try {
      await createAccount(accountDetails);
      context.commit(SET_EMAIL_VERIFICATION, {
        pendingEmailVerification: true,
        email: accountDetails.email
      });
      return true;
    } catch (e) {
      Err.handle(e);
    }
  },
  [VERIFY_ACCOUNT_EMAIL_CODE]: async (context, {
    email,
    code
  }) => {
    try {
      await verifyAccountEmailCode(email, code);
      return {
        success: true,
        message: ""
      };
    } catch (e) {
      var _e$responseJSON2;
      Err.handle(e);
      return {
        success: false,
        message: (_e$responseJSON2 = e.responseJSON) == null ? void 0 : _e$responseJSON2.message
      };
    }
  },
  [VERIFY_ACCOUNT_EMAIL_LINK]: async (context, {
    email,
    token
  }) => {
    try {
      var _context$state$email, _context$state;
      await verifyAccountEmail(email, token);
      const accountEmail = (_context$state$email = (_context$state = context.state) == null ? void 0 : _context$state.email) != null ? _context$state$email : "";
      if (email === accountEmail) context.commit(SET_EMAIL_VERIFIED, {
        verified: true
      });
      return {
        success: true,
        message: ""
      };
    } catch (e) {
      var _e$responseJSON3;
      Err.handle(e);
      return {
        success: false,
        message: (_e$responseJSON3 = e.responseJSON) == null ? void 0 : _e$responseJSON3.message
      };
    }
  },
  [RESEND_CONFIRMATION_LINK]: async (context, {
    email,
    currentSubdomain
  }) => {
    try {
      await resendConfirmationLink(email, currentSubdomain);
      return true;
    } catch (e) {
      Err.handle(e);
    }
  },
  [RESEND_CONFIRMATION_CODE]: async (context, {
    email
  }) => {
    try {
      await resendConfirmationCode(email);
      return true;
    } catch (e) {
      Err.handle(e);
    }
  },
  [RESEND_CONFIRMATION_EMAIL]: async (context, {
    email,
    currentSubdomain,
    locale,
    isResent
  }) => {
    try {
      await resendConfirmationLink(email, currentSubdomain, locale);
      context.commit(SET_EMAIL_SENT, true);
      showToast("success", isResent ? "checkEmailResent" : "checkEmailSent");
    } catch (e) {
      Err.handle(e);
    }
  },
  [CHECK_SUBDOMAIN]: async context => {
    let accountSubdomain = "";
    try {
      const redirectedByToken = await checkSubdomainRedirectionToken();
      if (redirectedByToken) return;
      const {
        token,
        accountDetails
      } = context.state;
      const path = window.location.pathname.replace("/", "").replace("#", "");
      const hasActiveSession = !!token;
      const endpoint = `/subdomain/${path}?client=true`;
      if (hasActiveSession) {
        accountSubdomain = accountDetails.accountSubdomain;
        if (!accountSubdomain) throw new Error("NoDomainInSession");
        if (path != accountSubdomain) throw new Error("NotUserDomain");
      }
      await getAccountsApi({}, endpoint, token);
    } catch (e) {
      Amplitude.logEvent("Domain not found - redirected to own domain", {
        error: e
      });
      if (e.message === "NoDomainInSession") return location.replace("/#");
      if (e.message === "NotUserDomain") {
        showToast("error", "redirecting");
        await delay(500);
        return location.replace(`/${accountSubdomain}`);
      }
    }
  },
  [LOAD_AGENT_ACCOUNT_DETAILS]: async (context, {
    pathname,
    hardReload
  } = {
    pathname: "",
    hardReload: false
  }) => {
    try {
      var _context3;
      if (!hardReload && !isEmpty(context.state.public.agentAccountDetails)) return;
      const token = context.rootGetters["ApplicationStandaloneStore/SESSION_TOKEN"];
      if (!pathname) pathname = `/${_sliceInstanceProperty(_context3 = window.location.pathname).call(_context3, 1)}`;
      const {
        accountDetails
      } = await getAgentAccountDetails(pathname, token);
      context.commit(SET_AGENT_ACCOUNT_DETAILS, accountDetails);
    } catch (e) {
      Err.handle(e, {}, "failedLoadingBrokerInformation");
    }
  },
  [CHECK_IF_EMAIL_ACCOUNT_EXISTS]: async (context, {
    email
  }) => {
    try {
      const {
        exists
      } = await checkIfAccountEmailExists(email);
      return exists;
    } catch (e) {
      Err.handle(e, {});
    }
  },
  [LOAD_ACCOUNT_AGENTS]: async context => {
    try {
      const agents = await getAgents();
      context.commit(SET_ACCOUNT_AGENTS, agents);
    } catch (e) {
      Err.handle(e, {});
    }
  },
  [LOAD_LENDER_DATA]: async (context, {
    urlId,
    offset
  }) => {
    try {
      const lenderData = await getLenderDocuments(urlId, offset);
      context.commit("SET_LENDER_DATA", {
        lenderData
      });
      context.commit("SET_DOCUMENTS_COUNT", {
        totalDocuments: lenderData.documentsCount
      });
      return lenderData;
    } catch (e) {
      Err.handle(e, {});
    }
  },
  [VERIFY_LENDER_PIN]: async (context, {
    urlId,
    code
  }) => {
    try {
      await verifyLenderCode(urlId, code);
      return {
        success: true,
        message: ""
      };
    } catch (e) {
      var _e$responseJSON4;
      Err.handle(e);
      return {
        success: false,
        message: (_e$responseJSON4 = e.responseJSON) == null ? void 0 : _e$responseJSON4.message
      };
    }
  },
  [DOWNLOAD_ALL_PDF]: async (context, {
    urlId,
    applicationId,
    documentIds
  }) => {
    let result = true;
    let error;
    const fileName = `${applicationId}.zip`;
    try {
      const {
        signedFileOptions
      } = await downloadAllDocumentsAsZip(urlId, documentIds);
      openFileDialog(signedFileOptions == null ? void 0 : signedFileOptions.url, signedFileOptions == null ? void 0 : signedFileOptions.documentId);
    } catch (e) {
      if (e.responseJSON) {
        result = false;
        error = e;
      } else {
        const response = await pollApiCall(async () => {
          return await downloadDocument(fileName, fileName);
        });
        if (response) openFileDialog(response == null ? void 0 : response.url, response == null ? void 0 : response.documentId);
      }
    }
    if (!result) {
      const message = error ? error.responseJSON : i18n.t("notification-messages.requestToDownloadDocumentTimedOut");
      Err.handle(error, {}, message);
      Amplitude.logEvent("BULK_DOWNLOAD_DOCUMENTS", {
        urlId,
        applicationId,
        submissionStatus: "failed",
        requestType: "zip"
      });
    }
    return result;
  },
  [DOWNLOAD_COMBINED_PDF]: async (context, {
    urlId,
    documentIds
  }) => {
    try {
      const {
        signedFileOptions: {
          url
        },
        warning,
        downloadedDocsIds
      } = await downloadAllDocumentsAsPdf(urlId, documentIds);
      return {
        url,
        warning,
        downloadedDocsIds
      };
    } catch (e) {
      Err.handle(e);
    }
  },
  [MARK_DOCUMENTS_DOWNLOADED]: async (context, {
    urlId,
    documentIds
  }) => {
    let result = true;
    try {
      await markDocumentsDownloaded(urlId, documentIds);
    } catch (e) {
      result = false;
      Err.handle(e);
    }
    return result;
  },
  [DOCUMENTS_ADDED_NOTIFICATION]: async (context, {
    notification: {
      type,
      message,
      title
    }
  }) => {
    showToast(type, message, title, type === "error" ? TOASTR_ERROR_OPTIONS : TOASTR_OPTIONS);
  },
  [LOAD_AGENT_DETAILS_WITH_SUBDOMAIN]: async context => {
    try {
      const path = window.location.pathname.replace("/", "");
      const endpoint = "/subdomain/subdomain-interstitial";
      const brokerageId = await getAccountsApi({
        path
      }, endpoint);
      context.commit("SET_BROKERAGE_ID", {
        brokerageId
      });
    } catch (e) {
      Err.handle(e);
    }
  },
  [LINK_CLIENT_WITH_BROKERAGE]: async (context, {
    agentUsername,
    clientUsername,
    email
  }) => {
    try {
      const path = window.location.pathname.replace("/", "");
      const endpoint = `/${path}/subdomain-interstitial`;
      const tiedBrokerages = await putAccountsApi({
        agentUsername,
        clientUsername,
        email
      }, endpoint);
      context.commit("SET_TIED_BROKERAGES", tiedBrokerages);
      return;
    } catch (e) {
      Err.handle(e);
    }
  }
};
export default actions;